import { useState, useEffect } from 'react';
import { useCreditUtilization } from '../../api/endpoints/debtorCreditUtilization';
import { CreditUtilizationResponse } from '@/app/features/DebtorPortal/Widgets/CreditUtilization/CreditUtilization.types';

interface UseCreditUtilizationWidgetOptions {
  debtorId: number;
  companyId: number;
  enabled?: boolean;
}

interface UseCreditUtilizationWidgetReturn {
  data: CreditUtilizationResponse | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const useCreditUtilizationWidget = ({
  debtorId,
  companyId,
  enabled = true,
}: UseCreditUtilizationWidgetOptions): UseCreditUtilizationWidgetReturn => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const { data, isLoading, isFetching, error } = useCreditUtilization(
    {
      debtorId,
      companyId,
      searchTerm: debouncedSearchTerm || undefined,
    },
    { enabled },
  );

  return {
    data,
    isLoading,
    isFetching,
    error: error as Error | null,
    searchTerm,
    setSearchTerm,
  };
};